<div class="h-full m-0 flex flex-col border-common">
  <y42-orchestration-diagram-toolbar></y42-orchestration-diagram-toolbar>

  <div class="grow h-full w-full relative">
    <div class="orchestration-diagram-container" #diagramRef>
      <div class="loader-container bg-squared-pattern" *ngIf="state.diagramLoading">
        <y42-logo-loader [widthInPixel]="70" class="center-absolute"></y42-logo-loader>
      </div>

      <y42-gojs-sidebar
        [diagram]="diagram"
        *ngIf="state.isDiagramEditable"
        [attentionNodePredicates]="attentionNodePredicates"
        [cdkDragBoundary]="diagramRef"
        [isCanvasEditable]="state.isOrchestrationEditable"
      ></y42-gojs-sidebar>

      <y42-gojs
        *ngIf="diagram"
        [diagram]="diagram"
        [dataLoading]="state.diagramLoading"
        [overviewPosition]="state.gojsOverviewPosition"
        [showContextMenu]="true"
      >
        <mat-card class="empty-placeholder-card mat-elevation-z0 bg-transparent">
          <mat-card-header class="flex flex-col-reverse items-center">
            <img *ngIf="orchestrationIcon" [src]="orchestrationIcon" class="w-[50px]" />
            <mat-card-title class="text-primary-800 text-4 my-[20px] font-semibold">Orchestration</mat-card-title>
          </mat-card-header>
          <mat-card-content class="flex flex-col items-center">
            <p class="text-base leading-relaxed text-center text-gray-700">
              With Orchestration you can create data pipelines with the Integrations, Models and Exports you created.
              You can trigger your orchestrations manually or run them on a schedule. Schedules can only be created and
              run on the default branch.
            </p>
          </mat-card-content>
        </mat-card>
      </y42-gojs>
    </div>

    <y42-gojs-legend
      *ngIf="diagram && !state.diagramLoading"
      [legendItems]="state.legends"
      [position]="state.gojsLegendPosition"
    ></y42-gojs-legend>
  </div>
</div>
